var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('choose-instance-name',{attrs:{"email":_vm.email,"lang":_vm.lang,"SubdomainAndEmailAvailability":_vm.SubdomainAndEmailAvailability},on:{"checkSubdomainAndEmailAvailability":_vm.onCheckSubdomainAndEmailAvailability,"proceedRegistration":_vm.onProceedInstanceRegistration}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a696c3d","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/professional/public/create-instance/step-1/page-create-instance-step-one.vue
// module id = 3109
// module chunks = 0